import { ReactNode } from "react";
import type { InfiniteListState } from "./toInfiniteListState";

import styles from "./InfiniteList.module.css";

interface Props<Item> extends InfiniteListState<Item> {
  emptyText: string;
  getKey: (item: Item) => number | string;
  renderItem: (item: Item) => ReactNode;
}

export const InfiniteList = <Item,>({
  items,
  isLoading,
  isError,
  isFetchingNextPage,
  onScroll,
  emptyText,
  getKey,
  renderItem,
}: Props<Item>) => {
  if (isLoading) return <p className={styles.placeholder}>Loading...</p>;
  if (isError && !items.length) {
    return <p className={styles.placeholder}>Failed to load. Try again.</p>;
  }
  if (!items.length) return <p className={styles.placeholder}>{emptyText}</p>;

  return (
    <ul className={styles.list} onScroll={onScroll}>
      {items.map((item) => (
        <li key={getKey(item)}>{renderItem(item)}</li>
      ))}
      {isFetchingNextPage && <li className={styles.placeholder}>Loading...</li>}
    </ul>
  );
};
